<article class="single-blog-details">
    <div class="blog-thumb">
        <a href="#"><img src="assets/img/case_studies_1.jpg" alt=""></a>
    </div>
    <div class="blog-content digimax-blog p-3">
        <div class="blog-details">
            <h3 class="blog-title py-3"><a href="#">What can the data tell me?</a></h3>
            <p class="d-block d-sm-block">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique placeat deleniti repellat alias maiores corrupti, commodi rem eum molestiae distinctio vitae perferendis at esse ex quas hic quis debitis quasi aspernatur incidunt, excepturi sapiente ducimus nisi. Ad molestiae, blanditiis ducimus.</p>
        </div>
    </div>
</article>